import styled from 'styled-components'
import useTranslation from '../../hooks/useTranslation'
import { Wrapper } from '../generic/Layout'
import RButton from '../generic/RButton'
import DropDown from '../generic/DropDown'
import { Icon_Dots } from '../../styles/icons'
import { useState, useRef, createPortal } from 'react'
import useOutsideClick from '../../hooks/useOutsideClick'

const TitleWrapper = styled(Wrapper)`
    margin-bottom: 0.5rem;
`

const MenuButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.font.color};

    &:hover {
        background-color: ${({ theme }) => theme.dropdown.active};
    }

    svg {
        width: 16px;
        height: 16px;
        margin: 0;
    }
`

const ActionMenu = styled.div`
    position: absolute;
    z-index: 1300;
    margin-top: 0px;
    margin-left: 30px;
`

const ActionContainer = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
`

const ButtonGroup = styled.div`
    display: flex;
    gap: 0.5rem;
    align-items: center;
`

const GridListTitle = ({ config, dirtyRows, onSave, onAction }) => {
    const { t } = useTranslation()
    const [menuOpen, setMenuOpen] = useState(false)
    const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 })
    const containerRef = useRef(null)

    useOutsideClick(containerRef, () => setMenuOpen(false), 'normal')

    if (!config.listHeader && !config.buttons && !config.menuItems) return null

    const hasDirty = dirtyRows && dirtyRows.size > 0

    const handleMenuToggle = (e) => {
        e.preventDefault()
        e.stopPropagation()
        const rect = e.currentTarget.getBoundingClientRect()
        setMenuPosition({
            top: rect.bottom + window.scrollY,
            left: rect.left + window.scrollX,
        })
        setMenuOpen(prev => !prev)
    }

    const handleMenuAction = (e, menuItem) => {
        e.preventDefault()
        e.stopPropagation()
        if (menuItem.action === 'save') {
            onSave?.()
        }
        setMenuOpen(false)
    }

    const handleButtonClick = (btn) => {
        if (btn.action === 'save') {
            onSave?.()
        } else {
            onAction?.(btn)
        }
    }

    return (
        <TitleWrapper>
            {config.listHeader && <h2>{t(config.listHeader.text)}</h2>}
            <ButtonGroup>
                {config.buttons?.map((btn, i) => (
                    <RButton
                        key={i}
                        $shadow={true}
                        $variant={btn.variant || 'primary'}
                        onClick={() => handleButtonClick(btn)}
                        label={btn.label}
                        icon={btn.icon}
                        testId={`gridList.btn.${btn.action}`}
                    />
                ))}
                {config.menuItems?.length > 0 && (
                    <ActionContainer ref={containerRef}>
                        <DropDown>
                            <MenuButton type="button" onClick={handleMenuToggle}>
                                {Icon_Dots}
                            </MenuButton>
                            {menuOpen &&
                                createPortal(
                                    <ActionMenu style={{ top: menuPosition.top, left: menuPosition.left }}>
                                        <DropDown.Menu role="menu">
                                            {config.menuItems.map((menuItem, index) => (
                                                <DropDown.Item
                                                    key={index}
                                                    href="#"
                                                    onClick={(e) => handleMenuAction(e, menuItem)}
                                                >
                                                    {t(menuItem.label)}
                                                </DropDown.Item>
                                            ))}
                                        </DropDown.Menu>
                                    </ActionMenu>,
                                    document.body
                                )}
                        </DropDown>
                    </ActionContainer>
                )}
            </ButtonGroup>
        </TitleWrapper>
    )
}

export default GridListTitle
